import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { GET_DASHBOARD_QUEUE_TASKS } from './actionTypes';
import { getDashboardQueueTasksSuccess, getDashboardQueueTasksError } from './actions';
import { taskStatusBack } from '../../../constants/task_fields';

// Include call API
import { getTasksAPI } from '../../../api/tasks';

const tasksAPI = getTasksAPI();

const QUEUE_STATUS = `${taskStatusBack.COLA},${taskStatusBack.COLA_RESERVA}`;

function* getDashboardQueueTasks({ payload: { user, size, page } }) {
  try {
    const response = yield call(tasksAPI.getTasks, user.token, size, page, QUEUE_STATUS);
    yield put(getDashboardQueueTasksSuccess(response.paginator, response.message));
  } catch (error) {
    yield put(getDashboardQueueTasksError(error));
  }
}

export function* watchGetDashboardQueueTasks() {
  yield takeEvery(GET_DASHBOARD_QUEUE_TASKS, getDashboardQueueTasks);
}

function* getDashboardQueueTasksSaga() {
  yield all([fork(watchGetDashboardQueueTasks)]);
}

export default getDashboardQueueTasksSaga;
